export default "__VITE_ASSET__CohNjY2U__"